import React, { useState } from "react";
import { motion } from "framer-motion";
import YouTube from "react-youtube";
import CustomButton from "../common/CustomBtn";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const fadeInLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const opts = {
  height: "100%",
  width: "100%",
  playerVars: {
    autoplay: 1,
    mute: 1,
    loop: 1,
    playlist: "wjWcHwQ4PLg",
  },
};

const Offers = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<number | null>(0);
  const handleChange =
    (index: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? index : null);
    };
  const offers = [
    {
      id: "01",
      title: t("products.playgrounds_page_list_title1"),
      description: t("products.playgrounds_page_list_desc1"),
    },
    {
      id: "02",
      title: t("products.playgrounds_page_list_title2"),
      description: t("products.playgrounds_page_list_desc2"),
    },
    {
      id: "03",
      title: t("products.playgrounds_page_list_title3"),
      description: t("products.playgrounds_page_list_desc3"),
    },
    {
      id: "04",
      title: t("products.playgrounds_page_list_title4"),
      description: t("products.playgrounds_page_list_desc4"),
    },
    {
      id: "05",
      title: t("products.playgrounds_page_list_title5"),
      description: t("products.playgrounds_page_list_desc5"),
    },
  ];
  return (
    <section className="relative w-full h-full px-[5%] py-16 md:py-24">
      <div className="maxContainer">
        <div className="flex flex-col items-center justify-between w-full gap-8 mb-12 md:mb-8 sm:items-end sm:flex-row">
          <div>
            <motion.h4
              initial="hidden"
              variants={fadeInLeft}
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="mb-4 text-sm font-bold text-primary ss:text-md"
            >
              {t("products.playgrounds_page_subheading")}
            </motion.h4>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={fadeInLeft}
              transition={{ delay: 0.2 }}
              className=" text-gray-700 sm:max-w-[829px]"
            >
              {t("products.playgrounds_page_desc")}
            </motion.p>
          </div>

          <div>
            <CustomButton
              variant="outlined"
              color="primary"
              onClick={() => navigate("/galerija#gallery-tab")}
            >
              {t("products.see_more_in_gallery")}
            </CustomButton>
          </div>
        </div>
        <div className="grid justify-between gap-12 md:gap-10 md:grid-cols-2">
          <div className="h-full">
            {offers.map((section, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={handleChange(index)}
                className="transition-all duration-500 ease-in-out border border-gray-200 shadow-md "
                sx={{
                  overflow: "hidden",
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      sx={{
                        color: expanded === index ? "#fff" : "#000",
                        transition: "color 0.3s ease-in-out",
                      }}
                    />
                  }
                  sx={{
                    backgroundColor:
                      expanded === index ? "primary.main" : "#fff",
                    color: expanded === index ? "#fff" : "#000",
                    transition:
                      "background-color 0.3s ease-in-out, color 0.3s ease-in-out",
                    padding: "5px 20px",
                  }}
                >
                  <h3 className="text-[20px] font-semibold">
                    {section.id}. {t(section.title)}
                  </h3>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    transition: "height 0.5s ease-in-out",
                    overflow: "hidden",
                    // paddingBottom: expanded === index ? "12px" : "0px",
                  }}
                >
                  <motion.div
                    className="p-2 space-y-4"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                  >
                    <div className="leading-relaxed text-gray-700 ">
                      {t(section.description)}
                    </div>
                  </motion.div>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>

          <div className="">
            <div className="flex justify-center w-full h-full min-h-[329px] bg-black">
              <YouTube
                videoId={"wjWcHwQ4PLg"}
                opts={opts}
                className="w-full min-h-[329px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offers;
